import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/infoedu/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-staff/infoedu/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/infoedu/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/infoedu/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/infoedu/remove',
  method: 'post',
  params: {
    ids,
  },
})
export default {
  getList,
  add,
  detail,
  update,
  remove,
}
